import { skipToken, useQuery, type UseQueryResult } from '@tanstack/react-query'
import apiClient from './axiosBase'

export interface ChannelTalkHashResponse {
  hash: string
}

export function useChannelTalkHashQuery (enabled?: boolean): UseQueryResult<ChannelTalkHashResponse, Error> {
  return useQuery<ChannelTalkHashResponse>({
    queryKey: ['channelTalk', 'hash'],
    queryFn: enabled === true
      ? async () => {
        const res = await apiClient.get<ChannelTalkHashResponse>('/v1/users/channel_talk_hash')
        return res.data
      }
      : skipToken,
    staleTime: 5 * 60 * 1000,
    refetchOnMount: false
  })
}
